import { paginationIntlIds } from './pagination.ids';

export const paginationLangEnUs = {
  [paginationIntlIds.pagination.loading]: 'Loading',
  [paginationIntlIds.pagination.items]:
    '{first_item_per_page}-{last_item_per_page} of {total_count} {total_count, plural, one {item} other {items}}',
  [paginationIntlIds.pagination.pages]:
    '<span>Page</span> <tag>{current_page}</tag> <span>of {last_page}</span>',
};
